import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * RemoddashLogo — Official universal logo component
 * 
 * Two logos defined globally:
 * 1. logo_full → "Remoddash" full branding image (for headers)
 * 2. logo_icon → "RE" compact icon (for footers)
 * 
 * Rules:
 * - Header (top-left) MUST ALWAYS use logo_full (type="full")
 * - Footer (bottom-left) MUST ALWAYS use logo_icon (type="icon")
 * - NEVER mix or swap logos
 */
const RemoddashLogo = ({ type = 'full', className = '', height }) => {
  const { isDark } = useTheme();
  const src = type === 'icon'
    ? '/logos/remoddash-icon.png'
    : '/logos/remoddash-full.png';

  const defaultH = type === 'icon' ? 28 : 36;
  const h = height || defaultH;

  return (
    <img
      src={src}
      alt={type === 'icon' ? 'RE' : 'Remoddash'}
      className={`object-contain ${className}`}
      style={{
        height: `${h}px`,
        filter: isDark
          ? 'none'
          : 'drop-shadow(0 0 1.5px rgba(0,0,0,0.3))',
        transition: 'filter 0.5s ease',
      }}
      data-testid={`remoddash-logo-${type}`}
    />
  );
};

export default RemoddashLogo;
